import { ScrollArea } from "@/components/ui/scroll-area";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { useEffect } from "react";

export default function TermsOfService() {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container py-8">
        <ScrollArea className="h-full">
          <div className="max-w-3xl mx-auto space-y-8">
            <h1 className="text-3xl font-bold">Terms of Service</h1>
            <p className="text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">1. Agreement to Terms</h2>
              <p>
                By accessing or using Habitualy (a Meetzi app), you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this service.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">2. Use License and Restrictions</h2>
              <p>
                Habitualy grants you a limited, non-exclusive, non-transferable, revocable license to use the service for personal, non-commercial purposes. You agree not to:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Modify, copy, or create derivative works of the service</li>
                <li>Use the service for any commercial purpose</li>
                <li>Attempt to decompile or reverse engineer the service</li>
                <li>Remove any copyright or proprietary notices</li>
                <li>Transfer your account to another person</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">3. Disclaimer of Warranties</h2>
              <div className="bg-muted p-4 rounded-lg">
                <p className="font-semibold uppercase">
                  THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT ANY WARRANTY OF ANY KIND, EXPRESS OR IMPLIED.
                </p>
                <p className="mt-2">
                  To the maximum extent permitted by law, Meetzi and Habitualy explicitly disclaim:
                </p>
                <ul className="list-disc pl-6 mt-2 space-y-2">
                  <li>Any warranty of merchantability, fitness for a particular purpose, or non-infringement</li>
                  <li>Any warranty regarding the reliability, availability, or accuracy of the service</li>
                  <li>Any warranty regarding the security of your data</li>
                  <li>Any warranty that the service will meet your requirements</li>
                  <li>Any warranty that the service will be error-free or uninterrupted</li>
                </ul>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">4. Limitation of Liability</h2>
              <div className="bg-muted p-4 rounded-lg">
                <p className="font-semibold uppercase">
                  IN NO EVENT SHALL MEETZI, HABITUALY, OR ITS AFFILIATES BE LIABLE FOR ANY DAMAGES WHATSOEVER.
                </p>
                <p className="mt-2">
                  This includes, without limitation:
                </p>
                <ul className="list-disc pl-6 mt-2 space-y-2">
                  <li>Direct, indirect, special, consequential, or incidental damages</li>
                  <li>Loss of profits, revenue, data, or business opportunities</li>
                  <li>Damages resulting from interruption of service</li>
                  <li>Damages from loss of data or data breaches</li>
                  <li>Damages from personal injury or emotional distress</li>
                  <li>Damages from inability to use the service</li>
                </ul>
                <p className="mt-4">
                  This limitation applies regardless of the basis of liability, and even if Meetzi or Habitualy has been advised of the possibility of such damages.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">5. Data Loss and Backup</h2>
              <p>
                You acknowledge and agree that:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Meetzi and Habitualy are not responsible for any loss of data</li>
                <li>You are solely responsible for backing up your data</li>
                <li>The service may experience downtime or technical issues that could result in data loss</li>
                <li>No compensation will be provided for any lost data</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">6. Modifications to Service</h2>
              <p>
                Meetzi reserves the right to:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Modify or discontinue the service at any time without notice</li>
                <li>Change these terms of service at any time without notice</li>
                <li>Modify pricing or features at any time</li>
                <li>Terminate your access to the service for any reason</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">7. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which Meetzi operates, without regard to its conflict of law provisions.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">8. Contact</h2>
              <p>
                For any questions regarding these Terms of Service, please contact us at support@meetzi.app
              </p>
            </section>
          </div>
        </ScrollArea>
      </main>
      <Footer />
    </div>
  );
} 